import Lottie from 'react-lottie-player';
import { Typography } from '@mui/material';
import movingDots from '@/lotties/dot_indicator.json';
import FlexBox from '@/components/FlexBox';
import theme from '@/app/theme';

const DashboardWatingDataFallback = ({ message }: { message: string }) => {
  return (
    <FlexBox
      style={{
        width: '100%',
        flex: 1,
        minHeight: '310px',
        borderRadius: '8px',
        backgroundColor: theme.palette.blue[100],
        overflow: 'hidden',
        gap: '8px'
      }}
    >
      <Lottie loop animationData={movingDots} play style={{ width: '24px', height: 'auto' }} />
      <Typography variant="subtitle2">{message}</Typography>
    </FlexBox>
  );
};

export default DashboardWatingDataFallback;
